import React, { Component } from 'react';
import loadScripts from '../../dassets/js/custom';
import api from '../api';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import store from "../redux/store";
import moment from 'moment';
// import qs from 'qs';

class Research extends Component {
  constructor(props) {
    super(props);

    this.state = {
        documents: [],
        page: this.props.match.params.page,
        pagenumber: 1
    }
  }
  componentDidUpdate() {
    if(this.state.page !== this.props.match.params.page){
    document.querySelector('#load-more').style.display = "block";
    this.setState({
        page: this.props.match.params.page,
        pagenumber: 1,
        documents: [],
    });
    setTimeout(() => this.fetchDocs(), 300);
    }
  }

  componentDidMount() {
    loadScripts();
    this.fetchDocs();
  }

  fetchDocs() {
    api.get(`/get/documents?pagename=${this.props.match.params.page}&page=${this.state.pagenumber}`)
    .then(response => {
      let pagenumber = this.state.pagenumber+1;
      let documents = [...this.state.documents, ...response.data.data];
        this.setState({
            documents: documents,
            pagenumber: pagenumber
        });
        if(response.data.data.length < 30){
          document.querySelector('#load-more').style.display = "none";
        }
    }).catch(error => {
        let err = store.getState().error;
        if (err) {
            toast.error(err.message);
            this.props.history.push(err.redirectUrl)
        }
        console.log(error)
    });
  }

  render() {
    return (
      <>
        {/* =================================
    Inner Header */}
        <div className="inner-header bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-sm-6 text-sm-start mb-2 mb-sm-0">
                <h1 className="breadcrumb-title mb-0">Research</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb d-flex justify-content-center justify-content-sm-end ms-auto">
                  <li className="breadcrumb-item"><Link to={"/"}><i className="fas fa-home me-1"></i>Home</Link></li>
                  <li className="breadcrumb-item"><span>Research</span></li>
                  <li className="breadcrumb-item active"><span style={{textTransform: 'capitalize'}}>{this.state.page}</span></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        {/* =================================
  Inner Header */}

        {/* =================================
  Tab */}
        <section className="space-ptb">
          <div className="container">
            {/* <div className="row d-flex align-content-center flex-wrap">
              <div className="col-md-12 align-self-center ps-3 ps-lg-5"> */}
                <div className="row">
                  {this.state.documents.map((doc,i) => {
                  return <div key={i} className="col-lg-2 col-md-3 col-sm-4 col-6 mb-md-5 mb-4">
                    <a target={'_blank'} href={`${process.env.REACT_APP_FILE_URL}/documents/${doc.path.replaceAll(/ +(?= )/g,'').replaceAll(/ |,/g,'_')}`}><div className="feature-info feature-info-style-1">
                      <div className="feature-info-icon text-center">
                        <i className="flaticon-research"></i>
                      </div>
                      {/* <div className="feature-info-cntent"> */}
                        {/* <h6 className="feature-info-title">Trusted and Secured</h6> */}
                        <div className='text-center' style={{textTransform: 'capitalize'}}>{doc.title.toLowerCase()}
                        {/* <br></br>{moment(new Date(doc.created_at)).format("DD/MM/YYYY")} */}
                        </div>
                      {/* </div> */}
                    </div></a>
                  </div>})
  }
                </div>
                <button id='load-more' className="btn btn-primary" onClick={() => this.fetchDocs()}>Load more <i className="fas fa-loading"></i></button>
              {/* </div>
            </div> */}
          </div>
        </section>
        {/* =================================
  Tab */}
      </>
    );
  }
}

export default Research;